import script from "./bin.vue?vue&type=script&setup=true&lang=js"
export * from "./bin.vue?vue&type=script&setup=true&lang=js"

import "./bin.vue?vue&type=style&index=0&id=49c8dbc6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c8dbc6"]])

export default __exports__